import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import groq from 'groq';
import {
  BENEFITS_V2,
  BLOG_CAROUSEL,
  COMPARISON_TABLE,
  FACTS,
  HERO_CAROUSEL,
  PRESS_QUOTES,
  PRODUCT_CAROUSEL,
  querySingletonDoc,
  QUOTE_CAROUSEL,
  REVIEWS_CAROUSEL,
  SEO,
  WALL_OF_LOVE,
} from 'lib/queries';
import { client } from 'lib/sanity';
import type { HomePage } from 'types/cms/pages/HomePage';

type HomePageQuery = UseQueryResult & {
  data: HomePage;
};

export const HOME_PAGE_KEY = 'homePage';

export const fetchHome = async () => {
  const query = groq`
    ${querySingletonDoc('timeline_home', 'home')} {
      ${SEO},
      ${HERO_CAROUSEL},
      reviewsCarousel -> {
        ${REVIEWS_CAROUSEL}
      },
      facts->{
        ${FACTS}
      },
      benefitsV2->{
        ${BENEFITS_V2},
      },
      comparisonTable -> {
        ${COMPARISON_TABLE}
      },
      pressQuotes {
        ${PRESS_QUOTES}
      },
      wallOfLove -> {
        ${WALL_OF_LOVE}
      },
      quoteCarousel {
        ${QUOTE_CAROUSEL}
      },
      productCarousel {
        ${PRODUCT_CAROUSEL}
      },
      blogCarousel -> {
        ${BLOG_CAROUSEL}
      }
    }
  `;

  const home: HomePage = await client.fetch(query);

  return home;
};

export const useHome = () =>
  useQuery({ queryKey: [HOME_PAGE_KEY], queryFn: fetchHome }) as HomePageQuery;
